/**
 * Carousel Utilities
 *
 * Additional carousel functionality and utilities
 * Note: Main carousel logic is embedded in lifestyle-section.liquid
 * This file can be extended for reusable carousel components
 */

(function() {
  'use strict';

  /**
   * Generic carousel initializer
   * Can be used for future carousel components
   */
  function initCarousel(container) {
    if (!container) return;

    const prevBtn = container.querySelector('[data-carousel-prev]');
    const nextBtn = container.querySelector('[data-carousel-next]');
    const slides = container.querySelectorAll('[data-carousel-slide]');
    const dots = container.querySelectorAll('[data-carousel-dot]');

    let currentIndex = 0;

    function showSlide(index) {
      // Ensure index is within bounds
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      // Hide all slides
      slides.forEach((slide, i) => {
        if (i === index) {
          slide.classList.add('active');
          slide.style.display = 'block';
        } else {
          slide.classList.remove('active');
          slide.style.display = 'none';
        }
      });

      // Update dots if they exist
      if (dots.length > 0) {
        dots.forEach((dot, i) => {
          if (i === index) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      currentIndex = index;
    }

    function nextSlide() {
      showSlide(currentIndex + 1);
    }

    function prevSlide() {
      showSlide(currentIndex - 1);
    }

    // Bind navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }

    // Bind dot navigation
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => showSlide(index));
    });

    // Keyboard navigation
    container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevSlide();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
      }
    });

    // Touch/swipe support (basic)
    let touchStartX = 0;
    let touchEndX = 0;

    container.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });

    container.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left
          nextSlide();
        } else {
          // Swipe right
          prevSlide();
        }
      }
    }

    // Initialize first slide
    showSlide(0);
  }

  /**
   * Initialize all carousels on the page
   */
  function initAllCarousels() {
    const carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(carousel => initCarousel(carousel));
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  // Re-initialize on Shopify section load (for theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAllCarousels);
  }
})();
